import * as icons from '@wix/auto_sdk_media-manager_icons';

export { icons };
